var map = {
	"./6.svg": 6852,
	"./Layer_1.svg": 1549,
	"./animate-stars.png": 2729,
	"./banner-vector.svg": 8928,
	"./banner-vector2.svg": 3340,
	"./blog1.png": 4659,
	"./blog2.png": 7519,
	"./blog3.png": 2183,
	"./card1.png": 733,
	"./card2.png": 8451,
	"./card3.png": 6370,
	"./card4.png": 4145,
	"./card5.png": 7131,
	"./card6.png": 9912,
	"./en.png": 260,
	"./icon1.svg": 6585,
	"./icon2.svg": 6796,
	"./icon3.svg": 1503,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./mask-group.png": 9597,
	"./mask-group.svg": 185,
	"./vector1.svg": 3084,
	"./vector2.svg": 8957,
	"./vector3.svg": 3413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;